const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/terms/${n}`);return r};export{e as getTermsById};
//# sourceMappingURL=get-terms-by-id.mjs.map